<template>
	<span :class="['eb-etiquette', {'eb-etiquette-light' : lightBg}, 'eb-etiquette-' + type]">
		<span v-if="iconBefore" class="eb-etiquette-icon">
			<font-awesome-icon v-if="type === 'error'" :icon="['fas', 'times-circle']" />
			<font-awesome-icon v-if="type === 'warning'" :icon="['fas', 'exclamation-circle']" />
			<font-awesome-icon v-if="type === 'success'" :icon="['fas', 'check-circle']" />
			<font-awesome-icon v-if="type === 'info'" :icon="['fas', 'info-circle']" />
			<font-awesome-icon v-if="type === 'waiting'" :icon="['fas', 'pause-circle']" />
		</span>
		<span><slot /></span>
		<font-awesome-icon v-if="closeIcon" :icon="['fas', 'times']" @click="$emit('removeEtiquette')" />
	</span>
</template>

<script>
/**
 * Textareas are used to allow users to provide text input when the expected
 * input is long. Textarea has a range of options. For shorter input,
 * use the `Input` element.
 */
export default {
	name: "EbEtiquette",
	status: "ready",
	release: "1.0.0",
	props: {
		/**
		 * The type of the etiquette.
		 */
		type: {
			type: String,
			default: "text",
			validator: value => {
				return value.match(/(theme|archive|error|warning|success|info|waiting)/)
			},
		},
		lightBg: {
			type: Boolean,
			default: false,
		},
		iconBefore: {
			type: Boolean,
			default: false,
		},
		closeIcon: {
			type: Boolean,
			default: false,
		},
	},
    methods: {
      removeEtiquette() {
        //
      }
    },
}
</script>

<style lang="scss" scoped>
.eb-etiquette {
	display: inline-flex;
	align-items: center;
	@include inset-squish-space($eb-space-default);
	@include inline-space($eb-space-m);
	@include stack-space($eb-space-default);
	border: $eb-border-default solid transparent;
	border-radius: $eb-radius-pill;
	width: auto;
	font-size: $eb-font-size-xxs;
    font-weight: $eb-font-weight-semibold;
	color: $white;
    margin-top: $eb-space-default;

	* {
		@include inline-space($eb-space-default);
	}

    .fa-times:hover,
    .fa-times:active,
    .fa-times:focus {
        cursor: pointer;
    }

	&-theme {
		background-color: var(--color-site-secondary);
	}
	&-archive {
		background-color: $eb-color-gray-700;
	}
	&-error {
		background-color: $eb-color-error;
	}
	&-warning {
		background-color: $eb-color-warning;
	}
	&-success {
		background-color: $eb-color-success;
	}
	&-info {
		background-color: $eb-color-info;
	}
	&-waiting {
		background-color: $eb-color-waiting;
	}

	&-light {
		&.eb-etiquette-theme {
            background-color: transparent;
			border-color: var(--color-site-secondary);
            color: var(--color-site-primary);
		}
		&.eb-etiquette-archive {
            background-color: transparent;
			border-color: $eb-color-gray-600;
            color: $eb-color-gray-700;
		}
		&.eb-etiquette-error {
			background-color: $eb-color-error-light;
            border-color: $eb-color-error-dark;
            color: $eb-color-error-dark;
            .eb-etiquette-icon {
                color: $eb-color-error;
            }
		}
		&.eb-etiquette-warning {
			background-color: $eb-color-warning-light;
            border-color: $eb-color-warning-dark;
            color: $eb-color-warning-dark;
            .eb-etiquette-icon {
                color: $eb-color-warning;
            }
		}
		&.eb-etiquette-success {
			background-color: $eb-color-success-light;
            border-color: $eb-color-success-dark;
            color: $eb-color-success-dark;
            .eb-etiquette-icon {
                color: $eb-color-success;
            }
		}
		&.eb-etiquette-info {
			background-color: $eb-color-info-light;
            border-color: $eb-color-info-dark;
            color: $eb-color-info-dark;
            .eb-etiquette-icon {
                color: $eb-color-info;
            }
		}
		&.eb-etiquette-waiting {
			background-color: $eb-color-waiting-light;
            border-color: $eb-color-waiting-dark;
            color: $eb-color-waiting-dark;
            .eb-etiquette-icon {
                color: $eb-color-waiting;
            }
		}
	}
}
</style>
